<input
    #elementRef
    [attr.type]="inputType$ | async"
    [formControl]="control"
    [id]="id"
    class="sh-input-field sh-form-group__input"
    [attr.min]="min || null"
    [attr.max]="max || null"
    [attr.autocomplete]="autocomplete || null"
    [attr.placeholder]="message$ | async"
    [attr.aria-describedBy]="invalid ? this.describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [attr.disabled]="disabled ? true : null"
    [step]="step$ | async"
    (focus)="focusChange($event)"
    (blur)="focusChange($event)"
/>
